import { serviceHandler } from './service-executor';

const HOME_SUMMARY_API = '/api/dispatch/summary';

export const getDispatchSummaryByDate = (date) => {
  let URL = `${HOME_SUMMARY_API}?date=${date}`;
  return serviceHandler(URL, 'GET');
};
